/********************************************************************
 * ADOBE CONFIDENTIAL
 * __________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *******************************************************************/

import { classes, Container } from '@adobe-commerce/elsie/lib';
import { AddressesProps } from '@/account/types';
import { AddressesWrapper } from '@/account/components';

const getDefaultFormName = (
  selectShipping: boolean,
  selectBilling: boolean
): string => {
  if (selectShipping && selectBilling) {
    return 'selectedAddress';
  } else if (selectShipping) {
    return 'selectedShippingAddress';
  } else if (selectBilling) {
    return 'selectedBillingAddress';
  }

  return 'default';
};

export const Addresses: Container<AddressesProps> = ({
  hideActionFormButtons,
  formName,
  slots,
  title,
  addressFormTitle,
  defaultSelectAddressId,
  showFormLoader,
  forwardFormRef,
  showSaveCheckBox,
  saveCheckBoxValue,
  selectShipping,
  selectBilling,
  selectable,
  className,
  withHeader,
  minifiedView,
  withActionsInMinifiedView,
  withActionsInFullSizeView,
  inputsDefaultValueSet,
  showShippingCheckBox,
  showBillingCheckBox,
  shippingCheckBoxValue,
  billingCheckBoxValue,
  onAddressData,
  routeAddressesPage,
  onSubmit,
  onSuccess,
  onError,
}) => {
  const minifiedViewKey = minifiedView ? 'minifiedView' : 'fullSizeView';
  const inputName =
    formName ?? getDefaultFormName(selectShipping!, selectBilling!);

  return (
    <div
      className={classes(['account-addresses', className])}
      data-testid="addressesid"
    >
      <AddressesWrapper
        inputName={inputName}
        minifiedViewKey={minifiedViewKey}
        hideActionFormButtons={hideActionFormButtons}
        slots={slots}
        title={title}
        addressFormTitle={addressFormTitle}
        defaultSelectAddressId={defaultSelectAddressId}
        showFormLoader={showFormLoader}
        onAddressData={onAddressData}
        forwardFormRef={forwardFormRef}
        selectShipping={selectShipping}
        selectBilling={selectBilling}
        showSaveCheckBox={showSaveCheckBox}
        saveCheckBoxValue={saveCheckBoxValue}
        selectable={selectable}
        className={className}
        withHeader={withHeader}
        minifiedView={minifiedView}
        withActionsInMinifiedView={withActionsInMinifiedView}
        withActionsInFullSizeView={withActionsInFullSizeView}
        inputsDefaultValueSet={inputsDefaultValueSet}
        billingCheckBoxValue={billingCheckBoxValue}
        shippingCheckBoxValue={shippingCheckBoxValue}
        showBillingCheckBox={showBillingCheckBox}
        showShippingCheckBox={showShippingCheckBox}
        routeAddressesPage={routeAddressesPage}
        onSubmit={onSubmit}
        onSuccess={onSuccess}
        onError={onError}
      />
    </div>
  );
};
